<template>

    <div class="detail-actions-page">
        <section>
            <div class="px-6 detail-page-header">
                <button type="button" class="btn btn-link text-decoration-none mb-2 detail-page-back" @click="$router.go(-1)" style="padding: 10px 0">
                    <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-2" />{{$t('back')}}
                </button>
            </div>
        </section>

        <section class="px-8 py-8">
                <div class="row">
                    <h3 class="mb-6 detail-page-title">{{$t('credit_note_details')}}</h3>

                                        <div class="col-md-4">
                        <div class="col-sm-12 mb-2">
                            <div class="card">
                                <div class="card-header">{{$t('information')}}</div>
                                <div class="card-body">
                                    <div>
                                        <div><b>{{$t('reference')}}</b>: {{invoice.reference}}</div>
                                        <div><b>{{$t('created_at')}}</b>: {{formatDate(invoice.created_at)}}</div>
                                        <div><b>{{$t('date')}}</b>: {{formatDate(invoice.date)}}</div>
                                        <div><b>{{$t('notes')}}</b>: {{invoice.notes}}</div>
                                        <div v-if="invoice.user"><b>{{$t('created_by')}}</b>: {{invoice.user.name}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card col-sm-12 mb-2">
                            <div class="card-header">{{$t('balance')}}</div>
                            <div class="card-body">
                                <div><b>{{$t('total')}}</b>: {{formatMoney(total)}} </div>
                                <div><b>{{$t('amount_paid')}}</b>: {{formatMoney(amount_paid)}}  </div>
                            </div>
                        </div>

                        <div class="card col-sm-12">
                            <div class="card-header">{{$t('client')}}</div>
                            <div class="card-body">
                                <div v-if="!invoice.client">{{$t('no_client_found')}}</div>
                                <div v-else>
                                    <div><b>{{$t('reference')}}</b>: {{invoice?.client?.reference}}</div>
                                    <div><b>{{$t('name')}}</b>: {{invoice?.client?.name}}</div>
                                    <div><b>{{$t('phone')}}</b>: {{invoice?.client?.phone}}</div>
                                    <div><b>{{$t('email')}}</b>: {{invoice?.client?.email}}</div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="card mb-4">
                            <div class="card-body p-0">
                                <invoice-template-modal v-if="invoice && invoice.id" inline :data="invoice" type="credit-invoice" />
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">{{$t('products')}}</div>
                            <div class="card-body table-responsive">
                                <table class="table mb-0 table-borderless table-striped small">
                                    <thead>
                                        <tr class="text-secondary">
                                            <th class="pt-4 pb-3 px-6">{{$t('product_label')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('price')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('quantity')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('vat')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('sub_total')}}</th>
                                            <th class="pt-4 pb-3 px-6">{{$t('total')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="product in invoice.products" :key="product.id">
                                        <td class="py-5 px-6">{{product.product_label}}</td>
                                        <td class="py-5 px-6">{{formatMoney(product.price)}}  </td>
                                        <td class="py-5 px-6">{{product.quantity}}</td>
                                        <td class="py-5 px-6">{{product.vat}} %</td>
                                        <td class="py-5 px-6">{{formatMoney(product.sub_total)}} </td>
                                        <td class="py-5 px-6">{{formatMoney(product.total)}}  </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-1 detail-page-actions detail-page-actions--stacked">
                        <button v-if="invoice.status != 'draft'" @click="ViewInvoice()" style="width:100%;padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="mb-1 btn btn-success btn-xs">
                            <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                            {{$t('invoice')}}</button> <br>
                        <button v-if="helper.checkAccess('edit_credit_invoices') != -1" @click="editRow()" style="width:100%;padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="mb-1 btn btn-success btn-xs detail-page-action--secondary">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                        </button> <br>
                        <button v-if="helper.checkAccess('edit_credit_invoices') != -1" @click="deleteRow()" style="width:100%;padding: 5px;margin: 0;font-size: 12px !important;" class="mb-1 btn btn-success btn-xs detail-page-action--danger">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                        </button> <br>
                        <!-- <button v-if="invoice.type !='credit_note' " class="mb-1 btn btn-success btn-xs dropdown-toggle" type="button" id="dropdownMenuButton1" style="width:100%;padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" data-bs-toggle="dropdown" aria-expanded="false">
                            <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right" style="font-size:12px" /> {{$t('transfert')}}
                        </button><br>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><a class="dropdown-item" style="cursor:pointer" @click="transferCreditNote()"> {{$t('credit_note')}}</a></li>
                        </ul> -->
                    </div>

                </div>

        </section>

            <section class="px-8 mb-8">
                <div class="card py-8 px-8">
                        <div>
                            <ul class="nav nav-tabs detail-page-tabs">
                                <li class="nav-item">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="step = 'attachments' " :class="step == 'attachments' ? 'active' : ''" >{{$t('attachments')}}</button>
                                </li>

                            </ul>

                            <nav class="nav nav-pills flex-column flex-sm-row mb-6">
                            </nav>

                            <div class="row mb-4">
                                <div class="col-12">
                                    <div class="tab-content" id="nav-tabContent">

                                    <div v-if="step == 'attachments'" class="show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                        <attachments :entity_id="invoice.id" entity_type="credit-note" />
                                    </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                </div>
            </section>


        <!-- quote modal -->
        <invoice-template-modal
            v-if="invoiceModalisOpen"
            @modalClosed="invoiceModalisOpen = false"
            modalId="invoice-invoice-modal-01"
            :isModalOpen="invoiceModalisOpen"
            :data="invoice"
            type="credit-invoice">
        </invoice-template-modal>
        <!-- quote modal -->

        <!-- create Modal -->
        <add-edit-credit-invoice-modal
            v-if="editModalisOpen"
            @modalClosed="editModalisOpen = false"
            modalId="create-credit-invoice-modal-01"
            :isModalOpen="editModalisOpen"
            :data="invoice"
            action="update"
        ></add-edit-credit-invoice-modal>
        <!-- create modal -->

    </div>

</template>

<script>
import helper from '../../helper'
import moment from 'moment'
import attachments from '../../components/Attachment.vue'
import AddEditCreditInvoiceModal from '../../components/creditInvoice/AddEditInvoiceModal';
import InvoiceTemplateModal from '../../components/invoiceLayout/InvoiceTemplateModal';

export default {
    name: 'CreditInvoiceDetails',
    components :{
        attachments,
        AddEditCreditInvoiceModal,
        InvoiceTemplateModal
    },
    data(){
        return {
            loading : false,
            invoice : {},
            amount_paid : 0,
            total_purchases : 0,
            total_quote : 0,
            step : 'attachments',
            invoiceModalisOpen : false,
            invoiceModal : null,
            editModal : null,
            editModalisOpen : false,
            createClientState : false
        }
    },
    created(){
        if(!this.$route.params || !this.$route.params.id) return this.$route.push('/deliveries')
        this.getInvoice(this.$route.params.id)
    },
    mounted(){
        window.mixpanel.track("credit_invoice_details");

        //check permissions
        if(helper.checkAccess('view_credit_invoices') == -1) return this.$router.push({path : '/'})
        if(helper.checkAccess('view_credit_invoices') == -2) return this.$router.push({path : '/subscribe'})

        // eslint-disable-next-line no-undef
        this.invoiceModal = new bootstrap.Modal(document.getElementById('invoice-modal'))
        // document.getElementById('invoice-modal').addEventListener('hidden.bs.modal', () => { this.invoiceBlModalisOpen = false })

        // eslint-disable-next-line no-undef
        this.editModal = new bootstrap.Modal(document.getElementById('edit-modal-quote'))
        // document.getElementById('edit-modal-quote').addEventListener('hidden.bs.modal', () => { this.editModalisOpen = false })

    },
    methods : {
        ViewInvoice(){
            this.invoiceData = this.invoice
            this.invoiceModalisOpen = true;
        },
        async getInvoice(id){
            try{
                this.loading = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/credit-invoices/${id}`)
                this.invoice = response.data
                this.total = this.invoice.total
                this.amount_paid = this.invoice.amount_paid
                this.loading = false

            }catch(error){
                this.$router.push({path : '/credit-invoices'})
                this.loading = false
            }
        },
         editRow(){
            this.editModalisOpen = true
            this.invoice.date = moment(this.invoice.date).format('YYYY-MM-DD')
        },
        selectTriggred(){
            this.calculatePrices()
        },
        calculatePrices(){
            this.$forceUpdate();
            for(let i = 0 ; i < this.invoice.products.length ; i++){
                this.invoice.products[i].total = parseFloat(this.invoice.products[i].price) * parseFloat(this.invoice.products[i].quantity)
                this.invoice.products[i].sub_total = Math.round(parseFloat(this.invoice.products[i].total))
                if(this.invoice.products[i].vat > 0){
                    this.invoice.products[i].total += parseFloat((parseFloat(this.invoice.products[i].total) * parseFloat(this.invoice.products[i].vat/ 100)).toFixed(2))
                    this.invoice.products[i].total = Math.round(this.invoice.products[i].total)
                }
            }
            this.invoice.total = this.invoice.products && this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        },
        parseTTctoHt(index,price){
            if(price && price > 0){
                this.invoice.products[index].price = ((price / this.invoice.products[index].quantity) / 1.2).toFixed(2)
                this.invoice.products[index].sub_total = parseFloat(this.invoice.products[index].price) * parseFloat(this.invoice.products[index].quantity)
            }
        },
        calculateItemPrice(){
            if(this.invoice.status == "draft") return 0
            return this.invoice.products && this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        },
        async updateRow(){
            try{
                this.loading = true
                this.invoice.products = helper.formatProducts(this.invoice.products, true)
                await helper.customPatch(`${process.env.VUE_APP_API}/credit-invoices/${this.invoice.id}`,{...this.invoice })
                this.loading = false
                this.clearForm()
                this.editModal.hide()
                this.getInvoice(this.$route.params.id)
            }catch(error){
                this.loading = false
            }
        },
        clearForm(){
            this.invoice = {
                id : null,
                reference : '',
                client_id : null,
                client : {},
                date : '',
                total : 0,
                products : []
            }
        },

        async deleteRow(){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/credit-invoices/${this.invoice.id}`)
                    this.getInvoice(this.$route.params.id)
                }
            })
        },
        emitAutoComplete(data){
            if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
                this.invoice.products[data.index] = {
                    ...{
                    inventory_id : data.result.id,
                    product_id : data.result.product.id,
                    label : data.result.product.label,
                    id : data.result.product.id,
                    quantity : 0,
                    maxQty : data.result.quantity,
                    price : data.result.price,
                    unity : data.result.unity,
                    purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                    vat :  data.result.vat ? data.result.vat : this.business.vat,
                    total : data.result.total ? data.result.total : 0,
                    sub_total : data.result.sub_total ? data.result.sub_total : 0,
                }}
                this.invoice.products = [...this.invoice.products]
            }
        },
        removeRow(i){
        this.invoice.products.splice(i, 1);
        },
        openCreateClientModal(){
            this.createClientState = !this.createClientState
        },
        emitAutoCompleteClient(data){
            this.invoice.client_id = data.result.id
            this.invoice.client = data.result
        },
        formatDate(date) { return helper.formatDate(date) },
        formatMoney(number) { return helper.formatMoney(number);}

    },
    computed : {
        business(){ return this.$store.getters.BUSINESS},
        helper(){ return helper },
        total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
        sub_total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0}
    }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
